export default __webpack_public_path__ + "static/media/eye.a46ca272.svg";